import React, { useState } from "react";
import "./SettingsPage.scss";
import AccountInformation from "./components/AccountInformation";
import Password from "./components/Password";
// import Subscriptions from "./components/Subscriptions";

const SettingsPage = () => {
  const [activeTab, setActiveTab] = useState("account");

  // Define tabs configuration for better maintainability
  const tabs = [
    {
      id: "account",
      label: "Account Information",
      component: <AccountInformation />,
    },
    {
      id: "password",
      label: "Password",
      component: <Password />,
    },
    // Uncomment when Subscriptions component is ready
    // {
    //   id: "subscriptions",
    //   label: "Subscriptions",
    //   component: <Subscriptions />
    // }
  ];

  // Handle tab selection with keyboard support
  const handleTabSelect = (tabId) => {
    setActiveTab(tabId);
  };

  const handleKeyDown = (e, tabId) => {
    if (e.key === "Enter" || e.key === " ") {
      e.preventDefault();
      setActiveTab(tabId);
    }
  };

  return (
    <div className="settings-page">
      <div className="settings-navigation">
        {tabs.map((tab) => (
          <div
            key={tab.id}
            className={`navigation-item ${
              activeTab === tab.id ? "active" : ""
            }`}
            onClick={() => handleTabSelect(tab.id)}
            onKeyDown={(e) => handleKeyDown(e, tab.id)}
            tabIndex={0}
          >
            {tab.label}
          </div>
        ))}
      </div>

      <div className="settings-content">
        {tabs.map(
          (tab) =>
            activeTab === tab.id && (
              <div key={tab.id} className="tab-content">
                {tab.component}
              </div>
            )
        )}
      </div>
    </div>
  );
};

export { SettingsPage };
